export default {
  COMMENT: 'comment',
  RESULT: 'result',
  STATUS: 'status'
};
